import { render, staticRenderFns } from "./quicks.vue?vue&type=template&id=7c6afeb4&scoped=true"
import script from "./quicks.vue?vue&type=script&lang=js"
export * from "./quicks.vue?vue&type=script&lang=js"
import style0 from "./quicks.vue?vue&type=style&index=0&id=7c6afeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6afeb4",
  null
  
)

export default component.exports